import EventBus from '../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import '../../../shared/js/wirebox/components/cached-script'
import '../../../shared/js/wirebox/utilities/get-hidden-input'
import '../../../shared/js/components/form-validation'
import '../../../shared/js/modules/error-modal'

//Define form selector
const selector = '.stripe-form'

class StripeFormComponent {
    
    /**
     * Construct module
     * @param forms
    */
    constructor(forms) {
        
        /**
         * Stripe elements
         * @type object
        */
        this.elements = null
        
        /**
         * Stripe form jQuery elements
         * @type object
        */
        this.forms = forms
        
        /**
         * Stripe module
         * @type object
        */
        this.stripe = null
        
        /**
         * Stripe input styling
         * @type object
        */
        this.style = {
            base: {
                fontSize: '16px'
            }
        }
        
        this.bindEvents()
        
    }
    
    /**
     * Run component
    */
    run() {
        
        //Download Stripe JS
        jQuery.cachedScript('https://js.stripe.com/v3/', {
            complete: this.stripeDownloaded.bind(this)
        })
        
    }
    
    /**
     * Stripe JS loaded
    */
    stripeDownloaded() {
        
        //Set Stripe variables
        
        this.stripe = Stripe(stripePublicKey)
        this.elements = this.stripe.elements()
            
        let
            cardElement,
            form
        
        //Setup forms
        this.forms.each((i, formElement) => {
            
            //Setup card
            cardElement = this.elements.create('card', {
                style: this.style
            })
            form = jQuery(formElement).css('visibility', '')
            cardElement.mount(form.find('.stripe-card')[0])
            form.data('card-element', cardElement)
            
            //Setup mobile button
            this.setupMobileButton(form)
            
        })
        
        //Broadcast event
        EventBus.publish('stripe.js.loaded')
            
    }
    
    /**
     * Setup mobile payment button
     * @param form
    */
    setupMobileButton(form) {
        
        //Cancel if form has no mobile button selector
        const selector = form.data('mobile-sel')
        if (!selector) {
            return
        }
        
        const button = jQuery(selector)
        
        //Cancel if button not found
        if (button.length === 0) {
            return
        }
        
        const paymentRequest = this.stripe.paymentRequest({
            country: form.data('country'),
            currency: form.data('currency'),
            requestPayerName: false,
            requestPayerEmail: false,
            total: {
                amount: form.data('total'),
                label: form.data('mobile-label')
            }
        })
        
        const prButton = this.elements.create('paymentRequestButton', {
            paymentRequest: paymentRequest,
        })
        
        paymentRequest.canMakePayment().then((result) => {
            if (result) {
                prButton.mount(selector)
            }
        })
        
        //Submit payment method
        paymentRequest.on('paymentmethod', (event) => {
            
            const paymentMethod = event.paymentMethod
      
            if (paymentMethod) {
                this.submitPaymentMethod(form, paymentMethod.id)
            }

            event.complete('success')
          
        })
        
        //Store payment request on form
        form.data('payment-request', paymentRequest)
        
    }
    
    /**
     * Form submission
     * @param event
    */

    async formSubmit(event) {
        
        const
            form = jQuery(event.target),
            paymentMethodSelect = form.find('.payment-method-select')
            
        //Prepare form submission
        EventBus.publish('prepare-form-submit', form)
        
        //Handle "use existing" behaviour
        if (paymentMethodSelect.length > 0 && paymentMethodSelect.is(':enabled') && paymentMethodSelect.val()) {
            form[0].submit()
            return
        }
        
        //Send card process request to Stripe
        
        const
            secret = form.find('.stripe-button').data('secret'),
            name = form.find('.card-holder').val()
        
        const {setupIntent, error} = await this.stripe.confirmCardSetup(
            secret,
            {
                payment_method: {
                    card: form.data('card-element'),
                    billing_details: {
                        name: name
                    }
                }
            }
        )
        
        //Handle error
        if (error) {
            
            //Un-prepare form submission
            EventBus.publish('unprepare-form-submit', form)
            
            //Display error
            EventBus.publish('error', {
                error: error.message,
                title: 'Could not complete payment'
            })
            
            return
            
        }
        
        //Submit payment method
        this.submitPaymentMethod(form, setupIntent.payment_method)
        
    }
    
    /**
     * Submit payment method
    */
    submitPaymentMethod(form, methodId) {
        
        EventBus.publish('prepare-form-submit', form)
        
        //Generate hidden input for payment method
        EventBus.publish('get-hidden-input', {
            form: form,
            name: 'payment_method',
            callback: (input) => {
                
                //Add payment method value to hidden input
                input.val(methodId)
                
                //Force form submit
                form[0].submit()
                
            }
        })
        
    }
    
    /**
     * Bind event listeners
    */
    bindEvents() {
        
        //Run module
        EventBus.subscribe('run-modules', this.run.bind(this))
        
        //Bind form success
        jQuery(document).on('form-success', selector, this.formSubmit.bind(this))
      
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    //Cancel if Stripe public key undefined
    if (typeof stripePublicKey != 'string' || !stripePublicKey) {
        return
    }
    
    const forms = jQuery(selector)
    
    if (forms.length > 0) {
        new StripeFormComponent(forms)
    }
    
})